<template lang="">
    <!-- чтобы хром не пытался их автозаполнить -->
    <input type='phone' style='display: block; width: 0px'/>
    <input type='password' style='display: block; width: 0px' />
    <!-- -->
    <div class="flex flex-wrap w-full justify-center  pb-32">
        <div class="flex flex-wrap flex-col max-w-xl m-auto rounded-md w-10/12 md:w-3/12 xl:w-3/12 2xl:w-3/12">
            <div class="flex flex-wrap flex-col rounded-3xl w-full shadow-lg bg-white p-2 px-4 dark:bg-stone-900"
                :class="[errors.length != 0 ? 'shake' : '']">
                <!-- <img src="https://t3.ftcdn.net/jpg/04/68/17/58/360_F_468175854_cEU6WqxN6Q504R3L7CkDI38Jkh7tYVH4.jpg" class="rounded-3xl w-full"/> -->
                <div class="pt-4 pb-2 text-center text-2xl"><h1>{{ loc('Регистрация в системе') }}</h1></div>
                <div class="pt-0 pb-4 text-center"><h1>{{ loc('Шаг') }} {{ step }} {{loc('из 2') }}</h1></div>
                <div v-show="step === 1 ">
                    <div class="p-2">
                        <label class="w-full">{{ loc('Номер телефона') }}</label>
                        <text-input
                            v-model="form.phone"
                            iconUrl="https://img.icons8.com/?size=512w&id=9730&format=png"
                            :placeholder="loc('Номер телефона')"
                            type="phone"
                            validate="phone"
                            ref="phoneInput"
                            required
                            containerClass="dark:bg-stone-700 dark:text-stone-900"
                            inputClass="dark:bg-stone-700 dark:text-stone-900"
                            />
                    </div>
                    <div class="p-2">
                        <label class="w-full">{{ loc('Пароль') }}</label>
                        <text-input
                            v-model="form.password"
                            iconUrl="https://img.icons8.com/ios-filled/256/lock-2.png"
                            :placeholder="loc('Пароль')"
                            type="password"
                            validate="min:4|max:25"
                            ref="passwordInput1"
                            containerClass="dark:bg-stone-700 dark:text-stone-900"
                            inputClass="dark:bg-stone-700 dark:text-stone-900"
                            />
                    </div>
                    <div class="p-2">
                        <label class="w-full">{{ loc('Повторите Пароль') }}</label>
                        <text-input
                            v-model="form.password_confirmation"
                            iconUrl="https://img.icons8.com/ios-filled/256/lock-2.png"
                            :placeholder="loc('Пароль')"
                            type="password"
                            validate="min:4|max:25"
                            ref="passwordInput2"
                            containerClass="dark:bg-stone-700 dark:text-stone-900"
                            inputClass="dark:bg-stone-700 dark:text-stone-900"
                            />
                    </div>
                    <div class="p-4 w-full flex-col justify-center items-center mt-2 select-none">
                        <div class="w-full flex flex-col justify-center items-center">
                            <div @click="gotoStep(2)" class="w-3/5 text-center cursor-pointer text-black py-3 px-4 focus:outline-none bg-lime-200 hover:bg-lime-300 active:bg-lime-900 rounded-full">Продолжить &rarr;</div>
                        </div>
                    </div>
                </div>
                <div v-show="step === 2 ">
                    <div class="p-2">
                        <label class="w-full">{{ loc('Фамилия') }}</label>
                        <text-input
                            v-model="form.last_name"
                            iconUrl="https://img.icons8.com/ios-glyphs/256/user.png"
                            :placeholder="loc('Фамилия')"
                            type="text"
                            validate="text|min:2|max:255"
                            required
                            containerClass="dark:bg-stone-700 dark:text-stone-900"
                            inputClass="dark:bg-stone-700 dark:text-stone-900"
                            />
                    </div>
                    <div class="p-2">
                        <label class="w-full">{{ loc('Имя') }}</label>
                        <text-input
                            v-model="form.first_name"
                            iconUrl="https://img.icons8.com/ios-glyphs/256/user.png"
                            :placeholder="loc('Имя')"
                            type="text"
                            validate="text|min:2|max:255"
                            required
                            containerClass="dark:bg-stone-700 dark:text-stone-900"
                            inputClass="dark:bg-stone-700 dark:text-stone-900"
                            />
                    </div>
                    <div class="p-2">
                        <div class="w-full pb-2">{{ loc('Зарегистрироваться как') }}</div>
                        <div class="flex flex-row items-center justify-around">
                            <div class="flex flex-row items-center">
                                <img src="https://img.icons8.com/?size=256w&id=23265&format=png" class="h-6 bg-white rounded-full" />
                                <input type="radio" id="role_passenger" value="passenger" v-model="form.role" class="ml-2 mr-2"/>
                                <label for="role_passenger">{{ loc('passenger') }}</label>
                            </div>
                            <div class="flex flex-row items-center">
                                <img src="https://img.icons8.com/?size=512w&id=3xOrU6jMUB6H&format=png" class="h-6 bg-white rounded-full" />
                                <input type="radio" id="role_transporter" value="transporter" v-model="form.role" class="ml-2 mr-2"/>
                                <label for="role_transporter">{{ loc('transporter') }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="p-2">
                        <label class="w-full">{{ loc('Промокод') }}</label>
                        <text-input
                            v-model="form.promocode"
                            iconUrl="https://img.icons8.com/?size=512w&id=9730&format=png"
                            :placeholder="loc('Промокод')"
                            type="text"
                            validate="text"
                            ref="promocodeInput"
                            required
                            containerClass="dark:bg-stone-700 dark:text-stone-900"
                            inputClass="dark:bg-stone-700 dark:text-stone-900"
                            />
                    </div>
                    <div class="p-4 flex items-center justify-between bg-stone-100 dark:bg-stone-800 mt-4 mx-2 rounded-md">
                        <input type="checkbox" v-model="form.agreed" class="ml-2 mr-6"/>
                        <div><a href="https://sultantaxi.kz/oferta.pdf" target="_blank" class="underline text-blue-500">{{ loc('Я прочитал и согласен с условиями пользовательского соглашения') }}</a></div>
                    </div>
                    <div class="p-4 w-full flex-col justify-center items-center my-2 select-none">
                        <div class="w-full flex flex-col justify-center items-center">
                            <button @click.prevent="saveForm" type="submit" class="w-4/5 text-center text-white bg-lime-600 border-0 py-3 px-4 focus:outline-none hover:bg-lime-500 active:bg-lime-900 rounded-full font-semibold">{{ loc('Зарегистрироваться') }}</button>
                        </div>
                    </div>
                </div>
                <div class="w-full py-4 mt-0 border-t flex justify-center">
                    <router-link :to="{ name: 'Login' }">
                        <div class="text-md text-center cursor-pointer hover:font-semibold hover:text-lime-700 hover:bg-lime-100 py-3 px-6 rounded-full">&larr; {{ loc('login_btn') }}</div>
                    </router-link>
                </div>
            </div>
            <div  v-if="errors.length > 0" class="flex justify-center px-8">
                <div class="p-4 w-full text-rose-500 text-center bg-red-100 rounded-br-md rounded-bl-md">
                    <div v-for="error, index in errors" :key="index">{{ error }}</div>
                </div>
            </div>
            <div v-else class="p-4">&nbsp;</div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            form: {
                password: '',
                password_confirmation: '',
                first_name: '',
                last_name: '',
                phone: '',
                agreed: true,
                role: "passenger",
                promocode: ''
            },
            step: 1,
            errors: []
        }
    },
    methods: {
        gotoStep (step) {
            this.errors = []
            switch (step) {
                case 1:
                    this.step = 1
                    break
                case 2:
                    if (!this.$refs.phoneInput.isValid) this.errors = this.$refs.phoneInput.validationErrors
                    else if (!this.$refs.passwordInput1.isValid) this.errors = this.$refs.passwordInput1.validationErrors
                    else if (!this.$refs.passwordInput2.isValid) this.errors = this.$refs.passwordInput2.validationErrors
                    else if (this.form.password !== this.form.password_confirmation) this.errors = ['Пароли не совпадают']
                    else this.step = 2
            }
        },
        saveForm () {
            if (!this.form.agreed) return this.errors = ['Условия пользовательского соглашения']
            this.$store
                    .dispatch('registerUser', this.form)
                    .then()
                    .catch((errors) => { this.errors = errors; this.step = 1; this.form.agreed = false })
                    .finally(() => setTimeout(() => { this.isLogginIn = false }, 300))
        }
    }

}
</script>
<style scoped>

    .shake {
        /* animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both; */
        animation: shake 0.62s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
        transform: translate3d(0, 0, 0);
    }

    @keyframes shake {
        10%,
        90% {
            transform: translate3d(-1px, 0, 0);
        }

        20%,
        80% {
            transform: translate3d(2px, 0, 0);
        }

        30%,
        50%,
        70% {
            transform: translate3d(-4px, 0, 0);
        }

        40%,
        60% {
            transform: translate3d(4px, 0, 0);
        }
    }
</style>
